export default {
  paged: {
    select: 'id,destinationUserId,processId,environmentId',
    searchSelect: [],
    notSelectSearch: 'destinationUser,process,environment',
    expand: {
      destinationUser: { select: 'fullName' },
      process: { select: 'name' },
      environment: { select: 'name' },
    },
  },
};
